import { render, staticRenderFns } from "./filter-goods.vue?vue&type=template&id=185d2b01&scoped=true"
import script from "./filter-goods.vue?vue&type=script&lang=js"
export * from "./filter-goods.vue?vue&type=script&lang=js"
import style0 from "./filter-goods.vue?vue&type=style&index=0&id=185d2b01&prod&scoped=true&lang=scss"
import style1 from "./filter-goods.vue?vue&type=style&index=1&id=185d2b01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185d2b01",
  null
  
)

export default component.exports